import IconCryptoEth from "cryptocurrency-icons/svg/color/eth.svg";
import IconCryptoBNB from "cryptocurrency-icons/svg/color/bnb.svg";
import IconCryptoPLY from "cryptocurrency-icons/svg/color/matic.svg";
import IconCryptoSOL from "cryptocurrency-icons/svg/color/sol.svg";
import IconCryptoAvax from "../assets/img/avax.png";
import IconCryptoMoonbase from "../assets/img/moonbase.png";
import IconCryptoFantom from "../assets/img/fantom.svg";
import algorandIcon from "../assets/ms-new-images/Algorand-logo.svg";

export const networkImages: any = {
  BSC: IconCryptoBNB,
  BSC_TESTNET: IconCryptoBNB,
  ETHEREUM: IconCryptoEth,
  RINKEBY: IconCryptoEth,
  POLYGON: IconCryptoPLY,
  MUMBAI_TESTNET: IconCryptoPLY,
  "Mumbai Testnet": IconCryptoPLY,
  SOLANA: IconCryptoSOL,
  AVAX_TESTNET: IconCryptoAvax,
  MOON_MOONBASE: IconCryptoMoonbase,
  AVAX_MAINNET: IconCryptoAvax,
  MOON_MOONRIVER: IconCryptoMoonbase,
  FTM_TESTNET: IconCryptoAvax,
  HARMONY_TESTNET_0: IconCryptoAvax,
  FTM_MAINNET: IconCryptoFantom,
  ALGORAND: algorandIcon,
};

// export const supportedIcons = {
//   FRM: "https://assets.coingecko.com/coins/images/8251/small/frm.png?1563777564",
//   ETH: IconCryptoEth,
//   RVF: "https://assets.coingecko.com/coins/images/14728/small/7.png?1618414105",
//   PAID: "https://assets.coingecko.com/coins/images/13761/small/PAID.png?1612493556",
// };
